import type { ComponentPropsWithoutRef } from 'react';
import { Link } from 'react-router';
import type { ExtraProps } from 'react-markdown';

import styles from './SupportArticlePage.module.css';

type SupportLinkProps = ComponentPropsWithoutRef<'a'> & ExtraProps;

/** Links between articles stay in the app; anything else opens in a new tab. */
export function SupportLink({ children, href, node: _node, ...rest }: SupportLinkProps) {
  if (href && (href === '/help' || href.startsWith('/help/'))) {
    return (
      <Link className={styles.link} to={href}>
        {children}
      </Link>
    );
  }

  return (
    <a {...rest} className={styles.link} href={href} rel="noreferrer" target="_blank">
      {children}
    </a>
  );
}
